var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#instagram_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#instagram_svg__b)",
    d: "M15.446 0H6.554A6.561 6.561 0 0 0 0 6.554v8.892A6.561 6.561 0 0 0 6.554 22h8.892A6.561 6.561 0 0 0 22 15.446V6.554A6.561 6.561 0 0 0 15.446 0Zm4.34 15.446a4.34 4.34 0 0 1-4.34 4.34H6.554a4.34 4.34 0 0 1-4.34-4.34V6.554a4.34 4.34 0 0 1 4.34-4.34h8.892a4.34 4.34 0 0 1 4.34 4.34v8.892Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#instagram_svg__c)",
    d: "M11 5.31A5.696 5.696 0 0 0 5.31 11 5.696 5.696 0 0 0 11 16.69 5.696 5.696 0 0 0 16.69 11 5.696 5.696 0 0 0 11 5.31Zm0 9.167a3.477 3.477 0 1 1 0-6.954 3.477 3.477 0 0 1 0 6.954Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#instagram_svg__d)",
    d: "M16.7 6.716a1.363 1.363 0 1 0 0-2.727 1.363 1.363 0 0 0 0 2.727Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "instagram_svg__b",
    x1: 11,
    x2: 11,
    y1: 21.936,
    y2: 0.171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E09B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C74C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C21975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7024C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "instagram_svg__c",
    x1: 11,
    x2: 11,
    y1: 21.936,
    y2: 0.171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E09B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C74C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C21975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7024C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "instagram_svg__d",
    x1: 16.701,
    x2: 16.701,
    y1: 21.936,
    y2: 0.171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E09B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C74C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C21975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7024C4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "instagram_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h22v22H0z"
  })))));
};
export { SvgInstagram as ReactComponent };
export default "data:image/svg+xml;base64,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";